import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Link} from 'react-router';
import {
  Grid,
  MenuItem,
  Drawer,
  Divider,
  Dialog,
  Button,
  Typography,
  Tooltip,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  ClickAwayListener,
  DialogActions,
  ListItem,
  List,
  DialogContent,
} from '@material-ui/core';
import {ChevronLeft as ChevronLeftIcon} from '@material-ui/icons';
import clsx from 'clsx';
import {
  HourglassEmpty as HourglassIcon,
  ExitToApp as ExitToAppIcon,
  InsertChart as InsertChartIcon,
} from '@material-ui/icons';
import {useWindowResize} from '@ozgene/gp5.hooks.use-window-resize';

function MyOzgeneDrawer(props) {
  const {
    onCloseDrawer,
    drawerOpen,
    dialogOpen,
    onOpenDialog,
    onCloseDialog,
    navTransitions,
    onLogout,
    classes,
    user,
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const {height} = useWindowResize();
  const [colonyMenuOpen, setColonyMenuOpen] = useState(false);
  const handleOpenColonyMenu = () => setColonyMenuOpen(true);
  const handleCloseColonyMenu = () => setColonyMenuOpen(false);
  const handleCloseDialog = () => {
    handleCloseColonyMenu();
    onCloseDialog();
  };
  const handleClickColony = (event) => {
    setAnchorEl(event.currentTarget);
    handleOpenColonyMenu();
  };
  const {authorities: userAuthorities} = user;

  return (
    <Drawer
      variant="permanent"
      open={drawerOpen}
      classes={{
        paper: clsx(classes.drawerPaper, !drawerOpen && classes.drawerPaperClose),
      }}
      style={{height: height}}
      width={256}
    >
      <div className={classes.toolbar}>
        <div className={classes.title}>
          <Typography variant="subtitle2" color="inherit">
            {process.env.REACT_APP_APP_NAME}
          </Typography>
          <Typography variant="caption">{process.env.REACT_APP_VERSION}</Typography>
        </div>
        <Tooltip title="Collapse">
          <IconButton onClick={onCloseDrawer}>
            <ChevronLeftIcon />
          </IconButton>
        </Tooltip>
      </div>

      <List component="nav">
        <Tooltip title="Model Development">
          <ListItem className={classes.drawerMenuItem} component={Link} to="/" button>
            <ListItemIcon className={classes.drawerIcon}>
              <HourglassIcon />
            </ListItemIcon>
            <ListItemText>Model Development</ListItemText>
          </ListItem>
        </Tooltip>
        <Divider />
        <Tooltip title="Breeding Colonies">
          <ListItem className={classes.drawerMenuItem} button onClick={handleClickColony}>
            <ListItemIcon className={classes.drawerIcon}>
              <InsertChartIcon />
            </ListItemIcon>
            <ListItemText>Breeding Colonies</ListItemText>
            <Menu
              style={{marginLeft: drawerOpen ? 224 : 57, marginTop: 7}}
              variant="menu"
              open={colonyMenuOpen}
              anchorEl={anchorEl}
              onClick={handleCloseColonyMenu}
            >
              <ClickAwayListener onClickAway={handleCloseColonyMenu}>
                <Grid>
                  <MenuItem key="perth" onClick={() => onOpenDialog('perth')}>
                    <ListItemText>Perth</ListItemText>
                  </MenuItem>
                  <MenuItem key="indy" onClick={() => onOpenDialog('indy')}>
                    <ListItemText>Indy</ListItemText>
                  </MenuItem>
                </Grid>
              </ClickAwayListener>
            </Menu>
          </ListItem>
        </Tooltip>
        <Divider />
        {navTransitions.map(
          ({icon, path, name, authorities}) =>
            !!userAuthorities &&
            userAuthorities.some((userAuth) =>
              authorities.some((auth) => auth === userAuth.name),
            ) && (
              <div key={path}>
                <Tooltip title={name}>
                  <ListItem className={classes.drawerMenuItem} component={Link} button to={path}>
                    <ListItemIcon className={classes.drawerIcon}>{icon ? icon : null}</ListItemIcon>
                    <ListItemText>{name}</ListItemText>
                  </ListItem>
                </Tooltip>

                <Divider />
              </div>
            ),
        )}
        <Tooltip title="Logout">
          <ListItem className={classes.drawerMenuItem} button onClick={onLogout}>
            <ListItemIcon className={classes.drawerIcon}>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </ListItem>
        </Tooltip>
        <Divider />
      </List>

      <Dialog title="Launching..." open={dialogOpen} onClose={handleCloseDialog}>
        <DialogContent>
          <Typography variant="h6">
            Please wait while we are preparing your breeding dashboard. You may need to allow
            pop-ups.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="secondary" key="cancel" onClick={handleCloseDialog}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Drawer>
  );
}

MyOzgeneDrawer.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  onCloseDrawer: PropTypes.func.isRequired,
  dialogOpen: PropTypes.bool.isRequired,
  onOpenDialog: PropTypes.func.isRequired,
  onCloseDialog: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  navTransitions: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default MyOzgeneDrawer;
